export default __webpack_public_path__ + "static/media/paymentgateway.14c63c11.png";